export default __webpack_public_path__ + "static/media/weatherapp.e16a12df.png";